module.exports = "/fonts/MetaPro-Light.woff?2a0009d21eeac6287020241ae714809c";